import React, { useState } from 'react'
import { BsCartCheck } from 'react-icons/bs';
import { AiOutlineExpand } from 'react-icons/ai';
import { IoShareSocialOutline } from 'react-icons/io5';
import { Link } from 'react-router-dom';
import { useDispatch } from "react-redux";
import { RWebShare } from "react-web-share";
import { useTranslation} from 'react-i18next';
import _ from 'lodash'
import BookingModal from '../../../page/bookingModal';

const ProductCard = (props) => {
    const { onPlus, onMinus, count, cartArray, enableBookAppointmentModal } = props;
    const { t, i18n } = useTranslation();

    return (
        <>
            <div className="product_wrappers_one">
                <div className="thumb">

                    <Link to={{
                        pathname: `/treatments/${(props.data.title.en).replaceAll(' ', '-').toLowerCase()}/${i18n.language}`,
                        state: {
                            service: props.data,
                            count: count,

                            cartArray: cartArray
                        }
                    }}
                        className={props.data.type === 'coupon' ? 'coupon' : "image"}>
                        <img src={process.env.REACT_APP_IMG_URL + props.data.image} />
                        <img className="hover-image" src={process.env.REACT_APP_IMG_URL + props.data.image}
                        />
                    </Link>
                    {/* <span className={(['hot','new','sale'][Math.round(Math.random()*2)])}>{props.data.discount} % Discount</span> */}
                    {/* {props.data.type!='coupon' && props.data.discount>0 &&  <span className="badges">
                   <span className='discount'>{props.data.discount} % Discount</span>
                      
                    </span>} */}
                    {/* {!props.hideButtons && <div className="actions">
                       {count>0 && <a className="action wishlist bg-adam" title="Wishlist"><BsCartCheck /></a>}
                        <a className="action quickview" title="Quick view" onClick={() => setModalShow(true)}><AiOutlineExpand /></a>
                       
                    </div>} */}
                    {/* {props.data.type!='coupon' && (count>0 ?<button type="button" className="add-to-cart offcanvas-toggle" onClick={onMinus}>Remove </button>:
                    <button type="button" className="add-to-cart offcanvas-toggle" onClick={onPlus}>Add to cart</button>)} */}
                </div>
             
                {props.data.type != 'coupon' && <div className="content">
                    <small className='text-warn font-weight-light'>{props.data.categoryId.title[i18n.language]}</small>
                    <h5 className="title">
                        <Link to={{
                             pathname: `/treatments/${(props.data.title.en).replaceAll(' ', '-').toLowerCase()}/${i18n.language}`,
                                state: {
                                service: props.data,
                                count: count,

                                cartArray: cartArray
                            }
                        }} >{props.data.title[i18n.language]}</Link>
                    </h5>
                    <small className='mb-3'>{props.data.description[i18n.language]?.replace(/<[^>]+>|\n|&nbsp;|&amp;/g, '').slice(0, 60) + '...'}</small>
                    
                    {/* {!props.data.disablePaymnet && <span className="price">

                        {props.data.type === 'package' ?
                                        <>
                                        <span className="new">{`${t('aed')} ${(props.data.enabledGlobalDiscount) ? props.data.price - _.round(((props.data.discount / 100) * props.data.price),1) : props.data.price}`} {props.data.discount != 0 && props.data.enabledGlobalDiscount && <del className='price-muted font-weight-normal'> {t('aed')} {props.data.price} </del>}  </span> 
                                        
                                        </>
                                        :

                                       (!props.data.disablePaymnet && <span className="new">{`${t('aed')} ${props.data.price - _.round(((props.data.discount / 100) * props.data.price),1)}`} {props.data.discount != 0 && <del className='price-muted font-weight-normal'> {t('aed')} {props.data.price} </del>}</span>)

                                    }


                    </span>} */}
                    
                    {/* <div className='row mb-2'>
                    {props.data.disablePaymnet ?
                    <div className='col mb-3'>
                    <span className='discount badge cart-label font-weight-light'>{t('consultationrequired')}</span>
                </div>
                    :
                    
                    <div className='col'>
                        {props.data.discount > 0 && props.data.enabledGlobalDiscount ? <span className='discount badge cart-label font-weight-light align-text-bottom'>{props.data.discount} % {t('discount')}</span>: props.data.discount > 0 && <span className='discount badge cart-label font-weight-light'>{props.data.discount} % {t('discount')}</span>}
                        </div>}
                        <div className='col text-right'>


                            {count > 0 && <BsCartCheck color='#d3ab50' />}


                            <RWebShare
                                data={{
                                    text: props.data.description[i18n.language].slice(0, 55) + '...',
                                    url: "http://localhost:3000/treatments/" + props.data.id,
                                    title: props.data.title[i18n.language],
                                }}
                                onClick={() => console.log("shared successfully!")}
                            >
                                <a className="action quickview ml-2" ><IoShareSocialOutline /></a>
                            </RWebShare>


                        </div>
                    </div> */}

                    {/* {
                        props.data.disablePaymnet ?
                            <button type="button" className="btn cartbtn btn-sm btn-block" onClick={enableBookAppointmentModal}>{t('bookappt')}</button>
                            :
                            count > 0 ? <button type="button" className="btn cartbtnadded btn-sm btn-block" onClick={onMinus}>{t('remove')}</button> :
                                <button type="button" className="btn cartbtn btn-sm btn-block" onClick={onPlus}>{t('addtocart')}</button>

                    } */}
                    <div className='row'>
                        <div className='col-xl-12 text-center'>
                        {/* <button type="button" className="btn cartbtn btn-sm" onClick={enableBookAppointmentModal}>{t('bookappt')}</button> */}
                        <BookingModal type="treatment" servicename={props.data.title[i18n.language]} service={props.data._id}/>
                        {props.data.type === 'package' ?   <RWebShare
                                data={{
                                    text: props.data.description[i18n.language].slice(0, 55) + '...',
                                    url: `https://aecmc.com/treatments/${(props.data.title.en).replaceAll(' ', '-').toLowerCase()}/${i18n.language}`,
                                  //  url: "http://localhost:3000/treatments/" + props.data.id,
                                    title: props.data.title[i18n.language],
                                }}
                                onClick={() => console.log("shared successfully!")}
                            >
                                <a className="action quickview ml-2 float-right" ><IoShareSocialOutline /></a>
                            </RWebShare>:
                            <RWebShare
                                data={{
                                    text: props.data.description[i18n.language].slice(0, 55) + '...',
                                    url: `https://aecmc.com/treatments/${(props.data.title.en).replaceAll(' ', '-').toLowerCase()}/${i18n.language}`,
                                    //url: "http://localhost:3000/treatments/" + props.data._id,
                                    title: props.data.title[i18n.language],
                                }}
                                onClick={() => console.log("shared successfully!")}
                            >
                                <a className="action quickview ml-2 float-right" ><IoShareSocialOutline /></a>
                            </RWebShare>
}
                    
                        </div>
                    </div>
                   
                </div>}

            </div>

            {/* <MyVerticallyCenteredModal data={props.data} show={modalShow} onHide={() => setModalShow(false)} /> */}
        </>
    )
}

export default ProductCard